import { Chakra } from "@airhelp/react-ui-components";
import Grid from "modules/common/components/Grid";
import type { HeroProps } from "./Hero.d";

const { Flex, Heading, Text, Box } = Chakra;

const Hero = ({ heading, subHeading, text }: HeroProps) => (
  <Grid mb={0}>
    <Box gridColumn={{ base: "span 1", md: "span 12" }}>
      <Flex flexDir="column" align={{ base: "flex-start", lg: "center" }}>
        <Text color="primary.500" fontSize="sm" mb={2} textTransform="uppercase" fontWeight="700" letterSpacing="wide">
          {subHeading}
        </Text>
        <Heading variant="h1" as="h1" mb={6}>
          {heading}
        </Heading>
        <Text
          fontSize="lg"
          maxW={{ base: "100vw", lg: "55vw", xl: "46vw" }}
          textAlign={{ base: "left", lg: "center" }}
          lineHeight="tall"
        >
          {text}
        </Text>
      </Flex>
    </Box>
  </Grid>
);

export default Hero;
